import { useQuery } from '@tanstack/react-query'

import {
  companyCertificateActivityApi,
  type CompanyCertificateActivityParams,
} from 'services/companyCertificateActivityApi'

export const COMPANY_CERTIFICATE_ACTIVITY_QUERY_KEY = ['company', 'certificate-activity'] as const

/**
 * The company's recent certificate activity (VRG-338) — scans, transfers, issuance.
 *
 * ⚠️ Distinct from `useCompanyActivity`, which is the admin AUDIT log (settings, roles, users)
 * behind Settings → Activity Log. See `companyCertificateActivityApi`'s docblock; the names
 * are close enough that picking the wrong one is easy and the mistake is silent, because both
 * return plausible-looking rows.
 *
 * COMPANY-scoped by default, narrowable to one actor via `actorUserId`. Which is the default
 * matters: the company feed is NEWS — a customer scanned a tag, an owner accepted a transfer,
 * none of which the viewer already knows. An admin's own feed is mostly a receipt for things
 * they just did. So Home asks for the company's, and "just mine" is the filter on top.
 */
export const useCompanyCertificateActivity = (
  params?: CompanyCertificateActivityParams,
  options?: { enabled?: boolean }
) =>
  useQuery({
    queryKey: [...COMPANY_CERTIFICATE_ACTIVITY_QUERY_KEY, params],
    queryFn: () => companyCertificateActivityApi.getCompanyCertificateActivity(params),
    enabled: options?.enabled !== false,
  })
